import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslation from "./en.json";
import esTranslation from "./es.json";
import itTranslation from "./it.json";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  en: {
    translation: enTranslation,
  },
  es: {
    translation: esTranslation,
  },
  it: {
    translation: itTranslation,
  },
};

const options = {
  order: ["localStorage"],
  lookupLocalStorage: "i18nextLng",
  caches: ["localStorage"],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    detection: options,

    fallbackLng: "es",

    supportedLngs: ["es", "en", "fr", "it"],

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
